import {default as cx} from "classnames"

import {getLocaleDate} from "../../utilities/general"

export const WeekDetailsAggregateAdditionalTab = ({osrs}) => {
    const questions = {}
    osrs.forEach((osr) => {
        osr.answers
            .filter((answer) => answer.category === "Additional Input")
            .forEach((answer) => {
                if (!questions[answer.question_order]) {
                    questions[answer.question_order] = {
                        question_text: answer.question_text,
                        question_type_id: answer.question_type_id,
                        max_answer_value: answer.max_answer_value,
                        submissions: [],
                    }
                }
                questions[answer.question_order].submissions.push({
                    shiftDate: osr.shift_date,
                    preceptorName: osr.preceptor_name,
                    answer: answer.answer,
                })
            })
    })

    return (
        <div className="tab-pane show active" id="add-tab" role="tabpanel">
            <div className="d-flex w-100 flex-column">
                <div className="container">
                    {Object.keys(questions).map((key) => {
                        const question = questions[key]

                        return (
                            <span key={key}>
                                <div className="d-flex flex-column w-100 fs-5">
                                    <div className="fw-bold mb-3">{question.question_text}</div>
                                    <div className="d-flex flex-column gap-4">
                                        {question.submissions.map((submission, index) => {
                                            return (
                                                <div
                                                    className="d-flex flex-column"
                                                    key={index + "-" + question.question_text}
                                                >
                                                    <div className="d-flex flex-row align-items-center gap-2 mb-1">
                                                        <span className="fw-bold">
                                                            {getLocaleDate(submission.shiftDate)}
                                                        </span>
                                                        <span className="text-muted">-</span>
                                                        <span className="fw-bold">
                                                            {submission.preceptorName
                                                                ? submission.preceptorName
                                                                : "Unknown"}
                                                        </span>
                                                    </div>
                                                    {[1, 8, 12, 13].includes(question.question_type_id) && (
                                                        <div className="rating">
                                                            {Array.from(
                                                                {length: question.max_answer_value},
                                                                (_, i) => (
                                                                    <div
                                                                        key={i}
                                                                        className={cx("rating-label me-1", {
                                                                            checked: submission.answer >= i + 1,
                                                                        })}
                                                                    >
                                                                        <i className="fas fa-square fs-3"></i>
                                                                    </div>
                                                                )
                                                            )}
                                                            <div className="ms-1 fw-bold fs-4">
                                                                {submission.answer}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {[3, 5].includes(question.question_type_id) && (
                                                        <div className="d-flex flex-row">{submission.answer}</div>
                                                    )}
                                                    {question.question_type_id === 6 && (
                                                        <div
                                                            className={cx(
                                                                "badge badge-lg align-self-start",
                                                                submission.answer === "Yes"
                                                                    ? "badge-success"
                                                                    : "badge-danger"
                                                            )}
                                                        >
                                                            {submission.answer}
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div className="separator border-1 border-secondary my-5"></div>
                            </span>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}
